<ng-template let-item="item">
    <div class="d-flex align-items-center">
        <div class="specialization-icon mr-5px" [style.background-image]="'url(' + assetUrl + item.icon + ')'"></div>
        <div class="specialization-name">{{item.name}}</div>
    </div>
</ng-template>
